export const setCategoryList = (state, categoryList) => {
  state.categoryList = categoryList;
};

export const setApplicationsList = (state, applicationsList) => {
  state.applicationsList = applicationsList;
};

export const setSolutionCategoriesList = (state, solutionCategoriesList) => {
  state.solutionCategoriesList = solutionCategoriesList;
};

export const setKpiValues = (state, KPIValues) => {
  KPIValues.forEach((kpiApp) => {
    let index = state.applicationsList.findIndex((app) => app.UUID === kpiApp.UUID);
    if (index > -1) {
      let app = state.applicationsList[index];
      state.applicationsList.splice(index, 1, { ...app, kpiValue: kpiApp.KPIValue });
    }
  });
};

export const removeKpiValues = (state) => {
  state.applicationsList &&
    state.applicationsList.forEach((app) => {
      delete app.kpiValue;
    });
};
